/* global ga */

'use strict';

import Promise from 'bluebird';
import $ from 'jquery';

const utils = {};

utils.transitionDone = function() {
	const el = document.createElement('fakeelement');
	const transitions = {
		'transition': 'transitionend',
		'OTransition': 'oTransitionEnd',
		'MozTransition': 'transitionend',
		'WebkitTransition': 'webkitTransitionEnd'
	};
	for (const t in transitions) {
		if (el.style[t] !== undefined) {
			return transitions[t];
		}
	}
};

utils.isMobile = function() {
	return $(window).width() < 1024
};

/**
 * Moved to jquery.fn.js
 */

/**
 * Serialize a form to object.
 * @return {Object}
 */
// $.fn.serializeObject = function() {
//   var o = {};
//   var a = this.serializeArray();
//   $.each(a, function() {
//     if (o[this.name] !== undefined) {
//       if (!o[this.name].push) {
//         o[this.name] = [o[this.name]];
//       }
//       o[this.name].push(this.value || '');
//     } else {
//       o[this.name] = this.value || '';
//     }
//   });
//   return o;
// };

/**
 * Test if browser supports a CSS property
 *
 * @param {String} property
 * @param {Array} [prefixes]
 * @param {Function} [callback]
 *
 * @return {Boolean|Function}
 */
utils.supportsCSSProperty = function(property, prefixes, callback) {
	if (typeof property === 'undefined')
		return;

	const div = document.createElement('div');
	let hasSupport = false;

	if (typeof div.style[property] !== 'undefined') {
		hasSupport = true;
	} else if (typeof prefixes !== 'undefined' && prefixes && prefixes.length) {
		property = property.charAt(0).toUpperCase() + property.substr(1);

		for (let i = 0; i < prefixes.length; ++i) {
			if ((prefixes[i] + property) in div.style) {
				hasSupport = true;
				break;
			}
		}
	}

	return typeof callback === 'function' ? callback(hasSupport) : hasSupport;
}

/**
 * Simple polyfill for images which use object-fit
 *
 * @param {Element} container
 */
utils.addObjectFitPolyfill = function(container = document) {
	const hasObjectFitSupport = utils.supportsCSSProperty('objectFit');

	if (!hasObjectFitSupport) {
		const images = container.querySelectorAll('.object-fit-polyfill');
		const styles = {
			backgroundSize: 'contain',
			backgroundPosition: ' center center',
			backgroundRepeat: 'no-repeat'
		};

		for (let i = 0; i < images.length; i++) {
			const image = images[i];
			const parent = image.parentNode;

			if (!image.classList.contains('object-fit-polyfilled')) {
				image.style.opacity = 0;
				image.classList.add('object-fit-polyfilled');
			}

			if (!parent.classList.contains('object-fit-polyfilled')) {
				styles.backgroundImage = `url(${image.src})`;

				for (const style in styles) {
					parent.style[style] = styles[style];
				}

				parent.classList.add('object-fit-polyfilled');
			}
		}
	}
}

/**
 * Check if GA is available or maybe disabled by the user
 *
 * @return {Boolean}
 */
utils.isGaAvailable = function() {
	return typeof ga !== 'undefined' && typeof ga.getAll === 'function' && !!ga.getAll().length;
}

/**
 * Ensure that an object has a given key, with the provded default value.
 *
 * @return {mixed} the value of the key
 */
utils.ensureProp = (obj, key, defaultVal) => {
	obj[key] = obj[key] || defaultVal;
	return obj[key];
}

/**
 * Ensure that a value is array.
 *
 * @param  {mixed} val
 * @return {Array}
 */
utils.ensureArray = (val => Array.isArray(val) ? val : [val].filter(Boolean));

const getLoader = (options = {}) => {
	let cls = 'form-loader';
	if (options.className) {
		cls += ' ' + options.className;
	}
	const $loader = $('<div>').addClass(cls).append($('<div>').addClass('spinner-loader-circle'));
	for (let i = 2; i < 13; i++) {
		$loader.append($('<div>').addClass('spinner-loader-circle spinner-loader-circle' + i));
	}
	return $loader;
}

/**
 * removeFormLoader
 */
utils.removeFormLoader = $container => {
	$container.find('.form-loader').remove();
	$container.siblings('.form-loader').remove();
}

/**
    $loader.insertAfter($container); break;
  default:
 * addFormLoader
 */
utils.addFormLoader = ($container, options = {}) => {
	utils.removeFormLoader($container);
	const $loader = getLoader(options);

	switch (options.align) {
		case 'before':
			$loader.insertBefore($container);
			break;
		case 'after':
			$loader.insertAfter($container);
			break;
		case 'replace':
			$container.html($loader);
			break;
		case 'append':
		default:
			$loader.appendTo($container);
			break;
	}

	const setLoaderStatus = (status) => $loader.addClass(status).html('<span class="loader-status"></span>');

	$container.addClass('loading');

	$loader.done = () => {
		$container.removeClass('loading');
		$loader.remove();
	}

	$loader.success = () => {
		$container.removeClass('loading');
		setLoaderStatus('success').append('<span class="is-icon is-icon-check-mark"></span>');
	}

	$loader.fail = () => {
		$container.removeClass('loading');
		setLoaderStatus('fail').append('<span class="is-icon is-icon-close"></span>');
	}
	return $loader;
}

/**
 * @return {Promise}
 */
utils.getToken = () => {
	return Promise.resolve($.ajax({
		url: '/stage-ajax/getToken',
		method: 'GET',
		cache: false,
		dataType: 'text'
	}));
}

utils.renderPrice = () => (text, render) => parseFloat(render(text)).toFixed(2).replace('.',',') + '&nbsp;&euro;';

export * from './ab-testing';
export * from './track-pages';
export { default as detectDevices } from './detect-devices';

export default utils;
